import React from "react"

import FileFile from './../images/icons/file-file.png'
import Attachment from './../images/icons/attachment.png'

import { url_base, imageExtensions, getExtension } from './../../Helper'

const RelatedFiles = ({ title, files, onClick }) => {

  return (
    <div className="radius-4 p-16 text-center mt-32" style={{ backgroundColor: 'rgba(255, 255, 255, .5)' }}>
      <h5 className="m-0">
        <span className="bg-tomato ml-4 icon-mask inline-blocked" style={{
          WebkitMaskImage: `url(${Attachment})`,
          WebkitMaskSize: 'contain',
          height: 24, width: 24, marginBottom: -8
        }} />
        {title}
      </h5>
      <hr className="my-16" />
      <div className="grid overflow-auto" style={{ gridRowGap: 8, maxHeight: 168, gridTemplateColumns: '1fr 1fr' }}>
        {
          files?.map((file, index) => (
            imageExtensions.includes(getExtension(file.file)) ?
              <button key={index} className="p-8 bd-none bg-none"
                onClick={() => onClick && onClick(index)}>
                <img src={url_base + file.file} alt="" />
              </button> :
              <button key={index} className="bd-none bg-none mx-8 p-0 iran-sans one-line">
                <a href={url_base + file.file} target="_blank">
                  <img src={FileFile} alt="" />
                </a>
              </button>
          ))
        }
      </div>
    </div>
  )
}

export default RelatedFiles
